<template>
    <div class="Com_view">
        <div class="box_carousel">
            <el-carousel trigger="click" height="48vw" :interval="5000" arrow="always"> 
                <el-carousel-item>
                    <el-image :src="require('../assets/index/轮播_1.jpg')"></el-image>
                </el-carousel-item>
              
                <el-carousel-item>
                    <el-image :src="require('../assets/index/轮播_2.jpg')"></el-image>
                </el-carousel-item>
                <el-carousel-item>
                    <el-image :src="require('../assets/index/轮播_3.jpg')"></el-image>
                </el-carousel-item>
            </el-carousel>
        </div>
        <!-- 企业简介 -->
        <div class="box_1 box_center">
            <div class="box_title">
                <span class="title">企业简介 / Enterprise brief introduction</span>
            </div>
            <div class="box_intro">
                <div class="box_text">
                    <div class="text">
                        广州市鸿年科技有限公司成立于1998年，经过20多年的发展，是国内从事医疗康复产品研发、开发、生产及销售的专业医疗技术公司。总部及研发生产基地位于广州市黄埔区国家级产业园区西陇创新园内。公司面积2400多平方米，目前拥有一批专业产品研发生产技术人员以及遍布全国的市场营销队伍，向顾客提供快捷高效的服务！ 公司成立以来，始终坚持以人才为本、诚信立业经营原则，荟萃业界精英，将国外先进技术、管理方法与企业自身实际相结合，提高企业管理水平和生产水平，使企业在激烈的市场竞争中始终坚持竞争力，实现企业快速、稳定地发展。
                    </div>
                    <div class="text">
                        我公司主要从事一类医疗器械压力绷带、二类医疗器械静脉曲张袜的生产，我们重视产品质量，公司坚持“质量第一、用户至上、以质兴业、以优取胜”的经营宗旨，关心行业健康发展，热心公益慈善事业，公司在中国整形美容行业及烧伤领域具有举足轻重的作用和地位。
                    </div>
                    <div class="text">
                        真诚携手，共赢同享，广州市鸿年科技有限公司愿与您携手共进，开创未来、实现梦想。
                    </div>
                    <!-- <div class="text">广州市鸿年科技有限公司是一家集 研发、生产、服务为一体的技术型企业，于1998年10月创立。公司主要产品有：</div>
                    <ul>
                        <li style="color:#462377;" class="wow animate__animated animate__fadeInUp ">
                            <span>1</span>欧力美®医用弹力套
                        </li>
                        <li style="color:#126434;" class="wow animate__animated animate__fadeInUp ">
                            <span>2</span>痕丽®烧伤定制
                        </li>
                        <li style="color:#CF1755;" class="wow animate__animated animate__fadeInUp ">
                            <span>3</span>必特酷®运动品牌
                        </li>
                        <li style="color:#370403;" class="wow animate__animated animate__fadeInUp ">
                            <span>4</span>蕾丝拜尔®美体塑身衣
                        </li>
                    </ul>
                    <div class="text">
                        等多个压力康复产品，总部位于广州市黄埔区西陇创新园。
                    </div>
                    <div class="text">
                        二十余年以来，一直秉承着 “一切以客户价值为依归” 的经营理念，致力于为更多客户提供更好产品及服务。
                    </div> -->
                </div>
                <div class="box_image">
                    <li><el-image class="flex_1" :src="require('../assets/index/介绍_1.jpg')"></el-image></li>
                    <li><el-image :src="require('../assets/index/介绍_2.jpg')"></el-image></li>
                    <li><el-image :src="require('../assets/index/介绍_3.jpg')"></el-image></li>
                    <li><el-image class="flex_1" :src="require('../assets/index/介绍_4.jpg')"></el-image></li>
                </div>
            </div>
        </div>
        <!-- 产品展示 -->
        <div class="box_2 box_center">
            <div class="box_title">
                <span class="title">品牌中心 / Brand center</span>
                <span class="btn" @click="onToProductPage">查看全部</span>
            </div>
            <div class="box_product">
                <ul>
                    <li @click="onToProductPage" title="下颌套" style="animation-delay: .3s;" class="flex_1 wow animate__animated animate__fadeInDown">
                        <el-image :src="require('../assets/product/产品展示/欧力美-医用弹力套/下颌套.jpg')"></el-image>
                    </li>
                    <li @click="onToProductPage" title="胸腹衣" style="animation-delay: .9s;" class="flex_2 wow animate__animated animate__fadeInUp">
                        <el-image :src="require('../assets/product/产品展示/欧力美-医用弹力套/胸腹衣.jpg')"></el-image>
                    </li>
                    <li @click="onToProductPage" title="塑身裤" style="animation-delay: .6s;" class="flex_2 wow animate__animated animate__fadeInUp">
                        <el-image :src="require('../assets/product/产品展示/欧力美-医用弹力套/塑身裤.jpg')"></el-image>
                    </li>
                </ul>
                <ul>
                    <li @click="onToProductPage" title="产后连体衣" style="animation-delay: .6s;"
                        class="flex_2 wow animate__animated animate__fadeInDown"><el-image
                            :src="require('../assets/product/产品展示/蕾丝拜尔-美体塑身衣/产后连体衣.jpg')"></el-image></li>
                    <li @click="onToProductPage" title="产后提臀裤" style="animation-delay: .9s;"
                        class="flex_2 wow animate__animated animate__fadeInDown"><el-image
                            :src="require('../assets/product/产品展示/蕾丝拜尔-美体塑身衣/产后提臀裤.jpg')"></el-image></li>
                    <li @click="onToProductPage" title="束腰连体衣" style="animation-delay: .3s;" class="flex_1 wow animate__animated animate__fadeInUp">
                        <el-image :src="require('../assets/product/产品展示/蕾丝拜尔-美体塑身衣/束腰连体衣.jpg')"></el-image>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 合作伙伴 -->
        <div class="box_3 box_center">
            <div class="box_title">
                <span class="title">合作伙伴 / Cooperative partner</span>
            </div>
            <div class="box_product">
                <dv-flyline-chart-enhanced :dev="true" :config="config" style="width:100%;height: 100%;margin:0 auto;" />
            </div>
        </div>
    </div>
</template>
  
<script>
import WOW from "wowjs";
export default {
    data() {
        return {
            config: {
                points: [
                    {
                        name: '0',
                        coordinate: [0.65, 0.84],
                    },
                    {
                        name: '1',
                        coordinate: [0.60, 0.93]
                    },
                    {
                        name: '2',
                        coordinate: [0.63, 0.86]
                    },
                    {
                        name: '3',
                        coordinate: [0.63, 0.86]
                    },
                    {
                        name: '4',
                        coordinate: [0.66, 0.80]
                    },
                    {
                        name: '5',
                        coordinate: [0.68, 0.81]
                    },
                    {
                        name: '6',
                        coordinate: [0.69, 0.83]
                    },
                    {
                        name: '7',
                        coordinate: [0.70, 0.81]
                    },
                    {
                        name: '8',
                        coordinate: [0.69, 0.83]
                    },
                    {
                        name: '9',
                        coordinate: [0.59, 0.80]
                    },
                    {
                        name: '10',
                        coordinate: [0.74, 0.72]
                    },
                    {
                        name: '11',
                        coordinate: [0.75, 0.74]
                    },
                    {
                        name: '12',
                        coordinate: [0.69, 0.72]
                    },
                    {
                        name: '13',
                        coordinate: [0.64, 0.73]
                    },
                    {
                        name: '14',
                        coordinate: [0.63, 0.70]
                    },
                    {
                        name: '15',
                        coordinate: [0.56, 0.72]
                    },
                    {
                        name: '16',
                        coordinate: [0.45, 0.78]
                    },
                    {
                        name: '17',
                        coordinate: [0.74, 0.66]
                    },
                    {
                        name: '18',
                        coordinate: [0.67, 0.65]
                    },
                    {
                        name: '19',
                        coordinate: [0.66, 0.66]
                    },
                    {
                        name: '20',
                        coordinate: [0.66, 0.63]
                    },
                    {
                        name: '21',
                        coordinate: [0.63, 0.62]
                    },
                    {
                        name: '22',
                        coordinate: [0.57, 0.64]
                    },
                    {
                        name: '23',
                        coordinate: [0.55, 0.66]
                    },
                    {
                        name: '24',
                        coordinate: [0.50, 0.63]
                    },
                    {
                        name: '25',
                        coordinate: [0.36, 0.63]
                    },
                    {
                        name: '26',
                        coordinate: [0.25, 0.51]
                    },
                    {
                        name: '27',
                        coordinate: [0.78, 0.60]
                    },
                    {
                        name: '28',
                        coordinate: [0.77, 0.62]
                    },
                    {
                        name: '29',
                        coordinate: [0.77, 0.60]
                    },
                    {
                        name: '30',
                        coordinate: [0.75, 0.61]
                    },
                    {
                        name: '31',
                        coordinate: [0.75, 0.58]
                    },
                    {
                        name: '32',
                        coordinate: [0.71, 0.58]
                    },
                    {
                        name: '33',
                        coordinate: [0.67, 0.56]
                    },
                    {
                        name: '34',
                        coordinate: [0.65, 0.53]
                    },
                    {
                        name: '35',
                        coordinate: [0.63, 0.55]
                    },
                    {
                        name: '36',
                        coordinate: [0.56, 0.56]
                    },
                    {
                        name: '37',
                        coordinate: [0.53, 0.53]
                    },
                    {
                        name: '38',
                        coordinate: [0.37, 0.51]
                    },
                    {
                        name: '39',
                        coordinate: [0.70, 0.48]
                    },
                    {
                        name: '40',
                        coordinate: [0.70, 0.37]
                    },
                    {
                        name: '41',
                        coordinate: [0.68, 0.40]
                    },
                    {
                        name: '42',
                        coordinate: [0.66, 0.41]
                    },
                    {
                        name: '43',
                        coordinate: [0.66, 0.38]
                    },
                    {
                        name: '44',
                        coordinate: [0.49, 0.38]
                    },
                    {
                        name: '45',
                        coordinate: [0.34, 0.36]
                    },

                ],
                lines: [
                    {
                        source: '1',
                        target: '0'
                    },
                    {
                        source: '2',
                        target: '0'
                    },
                    {
                        source: '3',
                        target: '0'
                    },
                    {
                        source: '4',
                        target: '0'
                    },
                    {
                        source: '5',
                        target: '0'
                    },
                    {
                        source: '6',
                        target: '0'
                    },
                    {
                        source: '7',
                        target: '0'
                    },
                    {
                        source: '8',
                        target: '0'
                    },
                    {
                        source: '9',
                        target: '0'
                    },
                    {
                        source: '10',
                        target: '0'
                    },
                    {
                        source: '11',
                        target: '0'
                    },
                    {
                        source: '12',
                        target: '0'
                    },
                    {
                        source: '13',
                        target: '0'
                    },
                    {
                        source: '14',
                        target: '0'
                    },
                    {
                        source: '15',
                        target: '0'
                    },
                    {
                        source: '16',
                        target: '0'
                    },
                    {
                        source: '17',
                        target: '0'
                    },
                    {
                        source: '18',
                        target: '0'
                    },
                    {
                        source: '19',
                        target: '0'
                    },
                    {
                        source: '20',
                        target: '0'
                    },
                    {
                        source: '21',
                        target: '0'
                    },
                    {
                        source: '22',
                        target: '0'
                    },
                    {
                        source: '23',
                        target: '0'
                    },
                    {
                        source: '24',
                        target: '0'
                    },
                    {
                        source: '25',
                        target: '0'
                    },
                    {
                        source: '26',
                        target: '0'
                    },
                    {
                        source: '27',
                        target: '0'
                    },
                    {
                        source: '28',
                        target: '0'
                    },
                    {
                        source: '29',
                        target: '0'
                    },
                    {
                        source: '30',
                        target: '0'
                    },
                    {
                        source: '31',
                        target: '0'
                    },
                    {
                        source: '32',
                        target: '0'
                    },
                    {
                        source: '33',
                        target: '0'
                    },
                    {
                        source: '34',
                        target: '0'
                    },
                    {
                        source: '35',
                        target: '0'
                    },
                    {
                        source: '36',
                        target: '0'
                    },
                    {
                        source: '37',
                        target: '0'
                    },
                    {
                        source: '38',
                        target: '0'
                    },
                    {
                        source: '39',
                        target: '0'
                    },
                    {
                        source: '40',
                        target: '0'
                    },
                    {
                        source: '41',
                        target: '0'
                    },
                    {
                        source: '42',
                        target: '0'
                    },
                    {
                        source: '43',
                        target: '0'
                    },
                    {
                        source: '44',
                        target: '0'
                    },
                    {
                        source: '45',
                        target: '0'
                    },

                ],
                bgImgSrc: require('../assets/partner/map_1.png'),
            }
        };
    },
    created() { },
    methods: {
        onToProductPage(){
            this.$router.push({
                path:"/product"
            })
        }
    },
    mounted() {
        new WOW.WOW().init();
    }
};
</script>
<style lang="less" scoped>
@media all and (max-width: 768px) {
    .Com_view {
        .box_center {
            padding: 20px 10% !important;
        }

        .box_1 {
            .box_image {
                width: 100% !important;
                margin-top: 20px;

                li {
                    width: 30% !important;
                    margin: 25px 20px !important;
                }
            }

        }

        .box_2 {
            .box_product {
                ul {
                    width: 100% !important;
                }
            }
        }

        .box_3 {
            .box_product {
                height: 50vw !important;
                padding: 30px 0 !important;
            }
        }
    }
}
</style>
<style lang="less" scoped>
.Com_view {
    .box_carousel{
        .el-image{
            width: 100%;
            height: 100%;
    }

    }
    .box_center {
        padding: 20px 15%;
        border-bottom: 1px dashed #DCDCDA;
    }

    .box_title {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
            color: #4e346e;
            font-size: 20px;
            position: relative;

            &::before {
                position: absolute;
                left: 0;
                bottom: -5px;
                border-radius: 5px;
                content: "";
                width: 80px;
                height: 2px;
                background: linear-gradient(to bottom, #cbabf1, #4e346e);
            }
        }

        .btn {
            font-size: 12px;
            padding: 5px 10px;
            border-radius: 50px;
            color: white;
            background: #CCD1D7;
            cursor: pointer;
            box-shadow: 0 2px 5px 0px rgba(183, 192, 206, 0.2);
        }


    }

    .box_1 {
        margin-top: 40px;
        .box_intro {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-bottom: 50px;

            .box_text {
                flex: 1;
                min-width: 300px;

                .text {
                    font-size: 14px;
                    margin-top: 30px;
                    margin-bottom: 10px;
                    line-height: 30px;
                    text-indent: 2rem;
                }

                // ul {
                //     display: flex;
                //     flex-direction: column;

                //     li {
                //         margin: 10px 0;
                //         font-size: 15px;
                //         display: flex;
                //         align-items: center;
                //         font-weight: bold;
                //         font-family: 黑体;

                //         span {
                //             display: flex;
                //             justify-content: center;
                //             align-items: center;
                //             width: 30px;
                //             height: 30px;
                //             color: #000;
                //             box-sizing: border-box;
                //             border: 1px solid #000;
                //             border-radius: 50px;
                //             margin-right: 10px;
                //             border-right: 1px dashed #000;
                //             border-top: 1px dashed #000;
                //         }

                //         &:nth-of-type(1) {
                //             animation-delay: 0;
                //         }

                //         &:nth-of-type(2) {
                //             animation-delay: .3s;
                //         }

                //         &:nth-of-type(3) {
                //             animation-delay: .6s;
                //         }

                //         &:nth-of-type(4) {
                //             animation-delay: .9s;
                //         }
                //     }
                // }
            }

            .box_image {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                width: 400px;

                li {
                    list-style: none;
                    width: 130px;
                    margin: 30px 25px;

                    .el-image {
                        box-shadow: 0 2px 5px 1px rgba(183, 192, 206, 0.5);
                        border-radius: 2px;
                        border: 2px solid white;
                        width: 100%;
                        transition: all .4s;
                        height: 100%;

                        &:hover {
                            transform: scale(1.2);
                        }
                    }

                    .flex_1 {
                        transform: scale(1.2);
                    }

                    &:nth-of-type(1){
                        animation: ImageUp 8s ease-in-out infinite;
                    }
                    &:nth-of-type(2){
                        animation: ImageDown 5s ease-in-out infinite;
                    }
                    &:nth-of-type(3){
                        animation: ImageUp 6s ease-in-out infinite;
                    }
                    &:nth-of-type(4){
                        animation: ImageDown 7s ease-in-out  infinite;
                    }
                }
            }
        }
    }

    @keyframes ImageUp {
        0% {
            transform: translateY(0);
        }

        50% {
            transform: translateY(-15px);
        }

        100% {
            transform: translateY(0);
        }
    }
    @keyframes ImageDown {
        0% {
            transform: translateY(0);
        }

        50% {
            transform: translateY(15px);
        }

        100% {
            transform: translateY(0);
        }
    }


    .box_2 {
        background: white;
        padding-top: 50px;

        .box_product {
            margin: 30px 0;
            margin-bottom: 50px;

            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            ul {
                width: 50%;
                display: flex;
                flex-wrap: wrap;

                li {
                    list-style: none;
                    margin: 12px;

                    .el-image {
                        box-shadow: 0 2px 5px 1px rgba(183, 192, 206, 0.5);
                        transition: all .5s;
                        height: 100%;

                        &:hover {
                            transform: scale(1.05);
                        }
                    }
                }
            }

            .flex_1 {
                width: 100%;
            }

            .flex_2 {
                flex: 0.5;
            }
        }
    }

    .box_3 {
        background: white;
        padding-top: 50px;

        .box_product {
            height: 30vw;
            padding: 30px 15%;
        }
    }

}
</style>